/**
 * 主要用来做防止重复提交之类的操作
 * doAsyncOperate需要返回Promise
 * @author menghao
 *
 * ---------------- demo ----------------
 * const handleConfirm = usePromiseCallback(onConfirm);
 */

import { useRef } from "react";
// import { errorMessage } from "./service";

export default function usePromiseCallback(
    doAsyncOperate: (...args: any) => Promise<void>
) {
    const isSending = useRef(false);

    const handleConfirm = async (...args: any[]) => {
        if (isSending.current) return;
        isSending.current = true;

        try {
            await doAsyncOperate(...args);
        } catch (e) {
            // console.error(errorMessage(e));
        }

        isSending.current = false;
    };

    return handleConfirm;
}
